export const API_FULL_URL = "https://nrjrm2be36.execute-api.us-west-2.amazonaws.com/production/lp";
// export const API_FULL_URL = "http://localhost:8080/lp";
export const API_CONTENT_TYPE = "application/json";
export const GITHUB_LPS_GIST_ID = null;
export const GITHUB_LP_VARIABLES_FILE_NAME = null;
export const GITHUB_FORMS_GIST_ID = null;

// Create an OAuth app in GitHub
// and add a token to it with no
// permissions.
export const READONLY_GIST_OAUTH_KEY = null;

export const LP_VARIANT_URL_PARAM = "h";
export const LP_VARIABLES_URL_PARAM = "vx";
export const FORM_VARIANT_URL_PARAM = "f";
export const OPEN_FORM_PARAM = "o";

export const CONTACT_FORM_ENDPOINT = 'contact';
export const ERROR_FALLBACK_ENDPOINT = undefined;

export const GTM_EVENTS = {
	stateInitialized: 'Global.stateInitialized',
	displayLoading: 'Global.displayLoading',
	fetchLpTemplateSuccess: 'Global.fetchLpTemplateSuccess',
	fetchLpTemplateError: 'Global.fetchLpTemplateError',
	fetchFormTemplateSuccess: 'Global.fetchFormTemplateSuccess',
	fetchFormTemplateError: 'Global.fetchFormTemplateError',
	resizedWindow: 'Global.resizedWindow',
	postFormSuccess: 'SurveyForm.postFormSuccess',
	postFormError: 'SurveyForm.postFormError',
	changedFormStep: 'SurveyForm.changedFormStep',
	startedChangingFormFieldValue: 'SurveyForm.startedChangingFieldValue',
	focusedOnFormField: 'SurveyForm.focusedOnField',
	focusedOutOfFormField: 'SurveyForm.focusedOutOfField',
	openedForm: 'SurveyForm.openedForm',
	closedForm: 'SurveyForm.closedForm',
	closedSuccessMessage: 'SurveyForm.closedSuccessMessage',
	openedContactForm: 'ContactForm.openedContactForm',
	startedChangingContactFormFieldValue: 'ContactForm.startedChangingFieldValue',
	focusedOnContactFormFieldValue: 'ContactForm.focusedOnField',
	focusedOutOfContactFormFieldValue: 'ContactForm.focusedOutOfField',
	closedContactForm: 'ContactForm.closedContactForm',
	postContactFormSuccess: 'ContactForm.postContactFormSuccess',
	postContactFormError: 'ContactForm.postContactFormError',
	closedContactFormSuccessMessage: 'ContactForm.closedSuccessMessage',
	openedMobileNavigation: 'Navigation.openedMobileNavigation',
	closedMobileNavigation: 'Navigation.closedMobileNavigation',
	navigatedToPage: 'Global.navigatedToPage',
	openedFooterDialog: 'Footer.openedFooterDialog',
	closedFooterDialog: 'Footer.closedFooterDialog',
}